module.exports = __webpack_public_path__ + "servicesHeaderBg.80b316ad06ed54b2f4a1.jpg";


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/assets/img/servicesHeaderBg.jpg
// module id = ../../../../../src/assets/img/servicesHeaderBg.jpg
// module chunks = main